module.exports = __webpack_public_path__ + "static/img/mcn.7ee713a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mcn.svg
// module id = DeDU
// module chunks = 2